export const it = {
  missingSetup: {
    title: 'First of all we need to set-up your account',
  },
  credits: {
    title: 'Crediti',
  },
};
